import React from 'react';
import * as Yup from 'yup';

import routes from 'app/routes';

import { Formik, Form as FormikForm, FieldArray } from 'formik';

import { Row, Col, Button } from 'react-bootstrap';

import { Link } from 'react-router-dom';

import {
  TextField,
  TextAreaField,
  SelectFieldV2,
  SubmitButton,
} from 'ui/FormElement';

import deleteIcon from 'images/icons/invite/delete.svg';
import sortUpIcon from 'images/icons/invite/sort-up.svg';
import sortDownIcon from 'images/icons/invite/sort-down.svg';

import reportTemplateSources from 'data/report_template_sources';
import Placeholders from './Placeholders';

export default function Index({ onSave, data }) {
  const FormSchema = Yup.object().shape({
    title: Yup.string().required('required'),
    steps: Yup.array().of(
      Yup.object().shape({
        title: Yup.string().required('required'),
        message: Yup.string().required('required'),
      }),
    ),
  });

  const formData = {
    title: data ? data.title : '',
    steps: data ? data.steps.map((item) => ({
      title: item.attributes.title,
      message: item.attributes.message,
      source: item.attributes.source,
      id: item.id,
    })) : [],
  };

  const onSubmit = (values, { setSubmitting, setErrors }) => {
    values.steps = values.steps.map((item, index) => ({
      ...item,
      position: index + 1,
    }));
    setSubmitting(true);
    onSave(values);
  };

  const moveItem = (array, fromIndex, toIndex) => {
    const item = array[fromIndex];
    const newArray = array.slice();
    newArray.splice(fromIndex, 1);
    newArray.splice(toIndex, 0, item);
    return newArray;
  };

  return (
    <Formik
      enableReinitialize
      validationSchema={FormSchema}
      initialValues={formData}
      onSubmit={onSubmit}
    >
      {({ values, isSubmitting, setFieldValue }) => (
        <FormikForm className="needs-validation" noValidate="">
          <div className="ibox-content mt20">
            <TextField
              name="title"
              label={(
                <>
                  <span>Name</span>
                  <abbr title="required">*</abbr>
                </>
            )}
            />
            <Placeholders />

            <FieldArray name="steps">
              {({ remove, push }) => (
                <div>
                  <h3>Steps</h3>
                  {values.steps.map(
                    (step, index) => (
                      <Row className="mt20">
                        <Col md={1}>{index + 1}</Col>
                        <Col md={9}>
                          <TextField
                            name={`steps.${index}.id`}
                            type="hidden"
                          />
                          <TextField
                            name={`steps.${index}.title`}
                          />
                          <TextAreaField
                            name={`steps.${index}.message`}
                          />
                          <SelectFieldV2
                            name={`steps.${index}.source`}
                            placeholder="Choose Data Source"
                            isMulti={false}
                            options={reportTemplateSources}
                            label={(
                              <span>Data Source</span>
                            )}
                          />
                        </Col>
                        <Col md={2}>
                          <Button
                            bsStyle="link"
                            style={{ padding: 5 }}
                            onClick={() => {
                              if (index > 0) {
                                const newItems = moveItem(values.steps, index, index - 1);
                                setFieldValue('steps', newItems);
                              }
                            }}
                          >
                            <img src={sortUpIcon} alt="delete" />
                          </Button>

                          <Button
                            bsStyle="link"
                            style={{ padding: 5 }}
                            onClick={() => {
                              if (index < values.steps.length - 1) {
                                const newItems = moveItem(values.steps, index, index + 1);
                                setFieldValue('steps', newItems);
                              }
                            }}
                          >
                            <img src={sortDownIcon} alt="delete" />
                          </Button>

                          <Button
                            bsStyle="link"
                            style={{ padding: 5 }}
                            onClick={() => remove(index)}
                          >
                            <img src={deleteIcon} alt="delete" />
                          </Button>
                        </Col>
                      </Row>
                    ),
                  )}
                  <div className="text-right">
                    <Button
                      onClick={() => push({
                        id: null, title: '', message: '', source: null,
                      })}
                      bsStyle="primary"
                    >
                      Add Step
                    </Button>
                  </div>
                </div>
              )}
            </FieldArray>

          </div>
          <div className="text-right mt20">
            <Link
              to={routes.admin.report_templates.index}
              className="btn btn-primary btn-outline mr5 ml5 width-120"
            >
              Cancel
            </Link>

            <SubmitButton
              title={isSubmitting ? 'Please, wait ...' : 'Save'}
              className={`btn width-120 btn-primary submit-button mr5 ml5 ${
                isSubmitting ? 'not-possible-click' : ''
              }`}
            />
          </div>
        </FormikForm>
      )}
    </Formik>
  );
}
